export let appetites = (state = appetites, action) => {
    switch (action.type) {
        case "REQUEST_APPETITES":
            return {};
        case "RECEIVE_APPETITES":
            return action.appetites;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/appetites.js